import {Typography, Dialog as MaterialUIDialog, AppBar, Toolbar, IconButton} from '@material-ui/core';
import React from 'react';
import './Dialog.sass';
import CloseIcon from '@material-ui/icons/Close';

type DialogProps = {
  title: string;
  onClose: () => void;
  children?: JSX.Element | JSX.Element[];
  open: boolean;
  fullScreen?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
};

const Dialog = ({children, fullScreen, maxWidth, onClose, open, title}: DialogProps) => {
  return (
    <MaterialUIDialog className="dialog" fullScreen={fullScreen} open={open} onClose={onClose} maxWidth={maxWidth}>
      <AppBar className="dialog__header">
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography className="dialog__header--title" variant="h6">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      {children}
    </MaterialUIDialog>
  );
};

export default Dialog;
